import { render, staticRenderFns } from "./EstoqueItemLimite.vue?vue&type=template&id=2fac98f5&"
import script from "./EstoqueItemLimite.vue?vue&type=script&lang=js&"
export * from "./EstoqueItemLimite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports